<div class="image-container">
  @if (data.images && data.images.length) {
    <img class="image" [src]="data.images![0]!.link" />
  } @else {
    <div class="empty-image">
      <span class="description">
        Upload a media file to preview the content
      </span>
    </div>
  }
</div>
<div class="content">
  <span class="headline">{{
    data.headlines?.length && data.headlines![0]?.length
      ? data.headlines![0]
      : "Your headline will appear here."
  }}</span>
  <div class="partner-info">
    @if (data.logos?.length) {
      <img class="logo" [src]="data.logos![0]!.link" />
    } @else {
      <div class="logo placeholder"></div>
    }
    <div class="description">
      {{
        data.descriptions?.length && data.descriptions![0]?.length
          ? data.descriptions![0]
          : "Your description will appear here."
      }}
    </div>
  </div>
</div>
